import { WebComponent } from '@cian/mf-registry/browser';
import * as React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';

import { Application } from '../../../shared/containers/App';
import { IApplicationContext } from '../../../shared/types/applicationContext';
import { TReduxStore } from '../../../shared/types/redux';

export function createHeaderConstructor(context: IApplicationContext, store: TReduxStore): CustomElementConstructor {
  class Header extends WebComponent {
    protected microfrontendName = context.config.getStrict<string>('projectName');
    protected imageVersion = context.config.getStrict<string>('version.commit');
    protected runtimeName = '/v2/get-header-microfrontend/';

    public async render() {
      const reactElement = <Application {...this.props} context={context} reduxStore={store} />;

      if (this.shouldHydrate) {
        hydrateRoot(this, reactElement);
      } else {
        createRoot(this).render(reactElement);
      }
    }
  }

  return Header;
}
